import { useQuery } from '@tanstack/react-query';
import React from 'react';

import { ObjectCard } from '@column/column-ui-kit';

import { ROUTE } from '~/app/routes';
import { useNavigate } from '~/lib/navigation';
import { Loan, LoanRepository } from '~/repositories/LoanRepository';
import { useSessionStore } from '~/stores/Session';

interface LoanCardProps {
  loanId: string;
}

const getLoanName = (loan?: Loan) => {
  if (!loan) return undefined;
  return loan.description || loan.id;
};

export const LoanCard: React.FC<LoanCardProps> = ({ loanId }) => {
  const navigate = useNavigate();
  const { currentPlatform } = useSessionStore();

  const {
    data: loan,
    isLoading,
    error,
  } = useQuery<Loan>({
    queryKey: [currentPlatform?.id, 'loan', loanId],
    queryFn: async () => LoanRepository.get(loanId),
    enabled: !!loanId,
    gcTime: 30000,
    staleTime: 10000,
  });

  const handleNavigate = () => {
    navigate(`${ROUTE.LOANS}/edit/${loanId}`);
  };

  return (
    <ObjectCard
      error={error ? 'Failed to load loan' : undefined}
      isLoading={isLoading}
      primaryText={getLoanName(loan) || 'Loan'}
      id={{ label: 'ID:', value: loanId }}
      onClick={handleNavigate}
    />
  );
};
